import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Servicios from "./components/Servicios";
import Galeria from "./components/Galeria";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";
import Social from "./components/Social";
import WhatsAppChat from "./components/WhatsAppChat";
import "./styles.css";

const App = () => {
  return (
    <Router>
      {/* 🔹 Contenedor principal */}
      <div className="min-h-screen relative">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/galeria" element={<Galeria />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/social" element={<Social />} />
        </Routes>
        <Footer />
        <WhatsAppChat />
      </div>
    </Router>
  );
};

export default App;
